import React, { useRef } from 'react'
import cx from 'classnames'
import styles from '../../../styles/HistoryPageEn.module.css'
import Head from 'next/head'
import BreadcrumbScroll from '../../../components/Elements/BreadcrumbScroll/BreadcrumbScroll'
import Image from 'next/image'
import { useInView } from 'framer-motion'
import YearHistory from '../../../components/Elements/YearHistory/YearHistory'
import { historyDateList } from '../../../components/Data/historyDate'
import StaticTopics from '../../../components/Elements/StaticTopics/StaticTopics'

const HistoryPage = () => {
  const refMainTitle = useRef()
  const isMainTitleInView = useInView(refMainTitle)

  const refLastRow = useRef()
  const isLastRowInView = useInView(refLastRow)

  return (
    <>
      <Head>
        <title>Our History - About Digikala Group</title>
        <meta
          name='viewport'
          content='initial-scale=1.0, width=device-width, maximum-scale=1'
        />
        <meta charSet='utf-8' />
        <meta
          name='description'
          content='We started working with online sales of electronic and digital products from 2015, but after changing to the Marketplace model from 2015, we entered a new stage, strange and of course full of'
        />
        <link rel='icon' type='image/x-icon' href='/faviconNew.svg'></link>
        <meta
          name='robots'
          content='index, follow, max-snippet:-1, max-video-preview:-1, max-image-preview:large'
        />
        <link rel='canonical' href={`https://about.digikala.com/en/history/`} />
        <meta property='og:locale' content='fa_IR' />
        <meta property='og:type' content='website' />
        <meta
          property='og:title'
          content='Our History - About Digikala Group'
        />
        <meta
          property='og:url'
          content={`https://about.digikala.com/en/history/`}
        />
        <meta property='og:site_name' content='About Digikala Group' />
        <meta property='og:image' itemProp='image' content='/ogImage.jpg' />
        <meta property='og:image:width' content='500' />
        <meta property='og:image:height' content='500' />
        <meta
          property='og:image:alt'
          content='Our History - About Digikala Group'
        />
        <meta property='og:image:type' content='image/png' />
        <meta
          property='og:site_name'
          content='Our History - About Digikala Group'
          key='ogsitename'
        />
        <meta
          property='og:title'
          content='Our History - About Digikala Group'
          key='ogtitle'
        />
        <meta
          property='og:description'
          content='We started working with online sales of electronic and digital products from 2015, but after changing to the Marketplace model from 2015, we entered a new stage, strange and of course full of'
          key='ogdesc'
        />
        <meta name='twitter:card' content='summary_large_image' />
        <meta
          name='twitter:title'
          content='Our History - About Digikala Group'
        />
        <meta
          name='twitter:description'
          content='We started working with online sales of electronic and digital products from 2015, but after changing to the Marketplace model from 2015, we entered a new stage, strange and of course full of'
        />
      </Head>
      <BreadcrumbScroll
        title='Our history'
        routeOne='/en/history'
        titleOne='Our history'
      />
      <div className='breadCrumbSpacer'></div>
      <div className={cx(styles.headerImageWrapper)}>
        <Image
          src='https://about.digikala.com/wp-content/uploads/2022/02/header-overview-2-1-1024x479.jpg'
          alt='Our history'
          unoptimized
          width={100}
          height={100}
        />
      </div>
      <h1
        style={{
          transform: isMainTitleInView ? 'none' : 'translateY(-100px)',
          opacity: isMainTitleInView ? 1 : 0,
          transition: 'all ease 1400ms'
        }}
        className='hOneStaticTitles text-center w-100 my-5 gilroyFontFamily'
      >
        Digikala from the past to today
      </h1>
      <div ref={refMainTitle}></div>
      <div className='container mb-5'>
        <p className='paragraphStaticPages text-center gilroyFontFamily'>
          {`
                        We started selling electronic and digital products online in 2005, but after changing to the
                    Marketplace model in 2015, we entered a new, strange phase, full of learning and responsibility.
                    What is now known as Digikala Group is a wide chain of online buying and selling of all goods with a
                    very high variety, and it also includes different platforms and services, each of which steps in the
                    path of value creation in Iran's digital economy. The history of Digikala Group has a story that we
                    will tell you.
                    `}
        </p>
      </div>
      {historyDateList.map((item, index, arr) => (
        <div key={index} className='w-100'>
          <YearHistory
            shamsiDate={item.shamsiDate}
            miladiDate={item.miladiDate}
            yearItems={item.items}
            reverse={index % 2 !== 0}
            isLast={arr.length - 1 === index}
          />
        </div>
      ))}
      <div className='container my-5 py-5'>
        <StaticTopics
          title='Digikala place Market has entered its 10th year of operation'
          paragraph={`After five years of operation and growing day by day, Digikala's market place platform has now entered its sixth year of operation. Now Digikala has become the home of all Iranian businesses. Digikala Marketplace is a platform that allows customers to buy from tens of thousands of different suppliers. More than 160,000 sellers have gathered in Digikala Marketplace to offer their products to Iran's 80 million people market, and buyers can get what they need by checking their products.`}
          isInView={isLastRowInView}
          divRef={refLastRow}
          imgaSrc='https://about.digikala.com/wp-content/uploads/2022/02/6th-anniversary.jpg'
          link='https://www.digikala.com/mag/video/6th-anniversary-marketplace-digikala/'
          linkTitle='Digikala visual identity guide'
        />
      </div>
    </>
  )
}

export default HistoryPage
